import { useState, useEffect } from 'react'
import { useProject } from '../stores/ProjectContext'
import { useI18n } from '../stores/I18nContext'
import './AxisModal.css'

export default function YAxisModal({ isOpen, onClose }) {
  const { project, updateProject } = useProject()
  const { language } = useI18n()
  const isNorwegian = language === 'nb'

  const [labels, setLabels] = useState([])

  useEffect(() => {
    if (project && isOpen) {
      const defaultLabels = isNorwegian
        ? ['Start', 'Fase 1', 'Fase 2', 'Fase 3', 'Fullført']
        : ['Start', 'Phase 1', 'Phase 2', 'Phase 3', 'Complete']
      setLabels(project.distanceLabels?.length > 0 ? [...project.distanceLabels] : defaultLabels)
    }
  }, [project, isOpen, isNorwegian])

  if (!isOpen) return null

  const handleLabelChange = (index, value) => {
    const newLabels = [...labels]
    newLabels[index] = value
    setLabels(newLabels)
  }

  const handleAddLabel = () => {
    const newLabel = isNorwegian ? `Fase ${labels.length}` : `Phase ${labels.length}`
    setLabels([...labels, newLabel])
  }

  const handleRemoveLabel = (index) => {
    if (labels.length > 2) {
      setLabels(labels.filter((_, i) => i !== index))
    }
  }

  const handleMoveUp = (index) => {
    if (index > 0) {
      const newLabels = [...labels]
      ;[newLabels[index - 1], newLabels[index]] = [newLabels[index], newLabels[index - 1]]
      setLabels(newLabels)
    }
  }

  const handleMoveDown = (index) => {
    if (index < labels.length - 1) {
      const newLabels = [...labels]
      ;[newLabels[index], newLabels[index + 1]] = [newLabels[index + 1], newLabels[index]]
      setLabels(newLabels)
    }
  }

  const handleSave = () => {
    updateProject({ distanceLabels: labels })
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="axis-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isNorwegian ? 'Y-akse konfigurasjon' : 'Y-axis Configuration'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p className="form-description">
            {isNorwegian
              ? 'Definer etiketter for Y-aksen (avstand/faser). Du kan legge til, fjerne og endre rekkefølge.'
              : 'Define labels for the Y-axis (distance/phases). You can add, remove, and reorder.'}
          </p>

          <div className="labels-list">
            {labels.map((label, index) => (
              <div key={index} className="label-row">
                <span className="label-index">{index}</span>
                <input
                  type="text"
                  value={label}
                  onChange={(e) => handleLabelChange(index, e.target.value)}
                  className="label-input"
                />
                <div className="label-actions">
                  <button
                    className="btn-icon"
                    onClick={() => handleMoveUp(index)}
                    disabled={index === 0}
                    title={isNorwegian ? 'Flytt opp' : 'Move up'}
                  >
                    ↑
                  </button>
                  <button
                    className="btn-icon"
                    onClick={() => handleMoveDown(index)}
                    disabled={index === labels.length - 1}
                    title={isNorwegian ? 'Flytt ned' : 'Move down'}
                  >
                    ↓
                  </button>
                  <button
                    className="btn-icon danger"
                    onClick={() => handleRemoveLabel(index)}
                    disabled={labels.length <= 2}
                    title={isNorwegian ? 'Fjern' : 'Remove'}
                  >
                    ×
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button className="btn btn-secondary add-label-btn" onClick={handleAddLabel}>
            + {isNorwegian ? 'Legg til etikett' : 'Add label'}
          </button>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            {isNorwegian ? 'Avbryt' : 'Cancel'}
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            {isNorwegian ? 'Lagre' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}
